export default class MessageTemplateService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('messages', params)
	}

	getRecipients(messageId, params) {
		return this.apiService.callGet('message/'+ messageId +'/recipients', params)
	}

	getDefaultValues(params){
		return this.apiService.callGet('message/default_values', params);
	}

	createEntity(params) {
		return this.apiService.callPost('message', params)
	}

	getNewMessageRecipients(params) {
		return this.apiService.callPost('message_recipients', params)
	}

	messageRecipientsCount(params) {
		return this.apiService.callPost('message_recipients_count', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('message/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('message/' + id, params)
	}

	deleteRecipient(id) {
		return this.apiService.callDelete('message/recipient/' + id);
	}
}



// WEBPACK FOOTER //
// ./src/service/MessageService.js